import { c as _c } from "react/compiler-runtime";
import { PackageIcon, Save01Icon, Trash02Icon } from '@systemeio/icons';
import { CurrencyEnum } from '@systemeio/types';
import { OfferConfigurationCard } from 'modules/funnels/funnel/components/step-configuration-tab/offer-configuration-card';
import { PhysicalOfferEditInterface, PhysicalOfferViewInterface } from 'modules/funnels/funnel/components/step-configuration-tab/offer-form-configuration-tab/types/physical-offer-interface';
import { usePhysicalProductSelector } from 'modules/funnels/funnel/components/step-configuration-tab/physical-product-selector/hooks/use-physical-product-selector';
import React, { useState } from 'react';
import { Button } from 'shared/components';
import Confirmation from 'shared/components/confirmation-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useMediaQuery from 'shared/hooks/use-media-query';
interface PhysicalProductSelectorProps {
  currency: CurrencyEnum;
  product: PhysicalOfferViewInterface['product'];
  draftProduct: PhysicalOfferEditInterface['product'];
  onSave: (data: PhysicalOfferEditInterface['product']) => Promise<void>;
  onRemoveDraft: () => void;
}
function PhysicalProductSelector(t0) {
  const $ = _c(38);
  const {
    currency,
    product,
    draftProduct,
    onSave,
    onRemoveDraft
  } = t0;
  const {
    isDesktop
  } = useMediaQuery();
  const {
    t
  } = useLocoTranslation();
  const [isFetching, setIsFetching] = useState(false);
  const [isRemoveConfirmationOpen, setIsRemoveConfirmationOpen] = useState(false);
  const savedProductId = product?.id ?? null;
  const isSaved = savedProductId !== null;
  const t1 = savedProductId ?? draftProduct;
  const t2 = isSaved || isFetching;
  let t3;
  if ($[0] !== currency || $[1] !== t1 || $[2] !== t2) {
    t3 = {
      currency,
      initialProduct: t1,
      disabled: t2
    };
    $[0] = currency;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    Select,
    localProduct
  } = usePhysicalProductSelector(t3);
  const hasChanged = localProduct !== savedProductId;
  let t4;
  if ($[4] !== onSave) {
    t4 = async product_0 => {
      setIsFetching(true);
      await onSave(product_0);
      setIsFetching(false);
    };
    $[4] = onSave;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleSave = t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <PackageIcon />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== isSaved || $[8] !== onRemoveDraft) {
    t6 = () => isSaved ? setIsRemoveConfirmationOpen(true) : onRemoveDraft();
    $[7] = isSaved;
    $[8] = onRemoveDraft;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Trash02Icon />;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== isFetching || $[12] !== t6) {
    t8 = <Button disabled={isFetching} onClick={t6} variant="secondary" size="icon-md">{t7}</Button>;
    $[11] = isFetching;
    $[12] = t6;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== handleSave || $[15] !== hasChanged || $[16] !== isDesktop || $[17] !== isFetching || $[18] !== localProduct || $[19] !== t) {
    t9 = hasChanged && <div className="mt-4 flex w-full justify-end"><Button onClick={e => {
        e.preventDefault();
        handleSave(localProduct ?? null);
      }} type="submit" isLoading={isFetching} variant="primary" size={isDesktop ? "sm" : "md"}><Save01Icon />{t("global.save")}</Button></div>;
    $[14] = handleSave;
    $[15] = hasChanged;
    $[16] = isDesktop;
    $[17] = isFetching;
    $[18] = localProduct;
    $[19] = t;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== Select || $[22] !== t8 || $[23] !== t9) {
    t10 = <OfferConfigurationCard icon={t5} content={Select} action={t8}>{t9}</OfferConfigurationCard>;
    $[21] = Select;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => setIsRemoveConfirmationOpen(false);
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== handleSave) {
    t12 = () => handleSave(null);
    $[26] = handleSave;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  const t13 = product?.name;
  let t14;
  if ($[28] !== t || $[29] !== t13) {
    t14 = t("dashboard.funnel.configuration.offer.physical_product_remove-description", {
      product: t13
    });
    $[28] = t;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== isRemoveConfirmationOpen || $[32] !== t12 || $[33] !== t14) {
    t15 = <Confirmation status="error" opened={isRemoveConfirmationOpen} onClose={t11} onConfirm={t12} confirmationText={t14} />;
    $[31] = isRemoveConfirmationOpen;
    $[32] = t12;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t10 || $[36] !== t15) {
    t16 = <>{t10}{t15}</>;
    $[35] = t10;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  return t16;
}
export default PhysicalProductSelector;